import { makeStyles, Theme } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: Theme) => ({
  dialogRoot: {},
  dialogPaper: {
    width: "100%",
    [theme.breakpoints.up(Breakpoints.SX_720)]: {
      maxWidth: 428
    }
  },
  dialogTitle: {
    position: "relative",
    padding: "24px 24px 16px 24px",
    textAlign: "left",
    fontSize: 20,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderBottom: `1px solid ${theme.palette.divider}`,
      padding: "0 8px",
      height: 50,
      maxHeight: 50,
      "& .MuiTypography-root": {
        fontSize: 18
      }
    }
  },
  dialogContent: {
    padding: 0
  },
  dialogContentTitle: {
    fontSize: 16,
    padding: "0 24px",
    textAlign: "left",
    [theme.breakpoints.down("xs")]: {
      padding: "0 16px"
    }
  },
  dialogActions: {
    display: "flex",
    justifyContent: "space-between",
    padding: "24px 8px 16px 12px",
    borderTop: "1px solid #eeeeee"
  },
  backButton: {
    color: theme.palette.primary.dark,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      position: "absolute",
      left: 10,
      textTransform: "none",
      fontSize: 16,
      height: 32
    }
  },
  backButtonHeader: {
    [theme.breakpoints.up(Breakpoints.SX_720)]: {
      display: "none"
    }
  },
  backButtonFooter: {
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      display: "none"
    }
  },
  confirmButton: {
    color: theme.palette.secondary.dark,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      color: theme.palette.common.white,
      width: "100%",
      backgroundColor: theme.palette.secondary.dark,
      textTransform: "none"
    }
  },
  reviewRow: {
    "&>td:first-child": {
      paddingLeft: 24,
      whiteSpace: "nowrap"
    },
    "&:nth-child(2n)": {
      backgroundColor: "#f7f7f7"
    }
  },
  reviewRowCell: {
    wordBreak: "break-word"
  },
  actionsReviewButton: {
    minWidth: 188,
    height: 46,
    backgroundColor: theme.palette.secondary.dark,
    color: theme.palette.common.white,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#5db491"
    }
  },
  actionsReviewButtonDisabled: {
    "&.Mui-disabled": {
      backgroundColor: theme.palette.grey[200]
    }
  },
  capitalize: {
    textTransform: "capitalize"
  }
}));
